// extracted by mini-css-extract-plugin
module.exports = {"selector":"styles-module--selector--521f3f","item":"styles-module--item--986751"};